
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexWYApO3GeiZtP9wqzfhIqU0HfrZXJAIChUCq03rDbKYkMeta } from "/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/index.vue?macro=true";
import { default as offlinesVr54yhyvJ1LZ9vQD3C8Ihv1PFEUyLvOOYuF1nFAbXYMeta } from "/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/offline.vue?macro=true";
import { default as indexXFLmaM8Fg6kkaSQzlmotpFCM0cidHJBCi0vZ4rkpn8EMeta } from "/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/login/index.vue?macro=true";
import { default as indexCC9O_cLMARvWaa6gQHjZ_Ghzt_6WztSG1f5D_45P2x_OAMeta } from "/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/logout/index.vue?macro=true";
import { default as token1A1cl6_45jFxr_prfaNpqaG21UDxhgvkEG12Gvc7L8geoMeta } from "/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/redirect/token.vue?macro=true";
import { default as indexS7vzSQCNplOFg9k3Es30P9a0C43vZ3bEtevuzKHlP0UMeta } from "/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/schedule/index.vue?macro=true";
import { default as indexuJ4ocsEYmNNHQvvDFJ_45gjC0sZPOqY3oP5cW_IIQ4nOQMeta } from "/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/students/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexWYApO3GeiZtP9wqzfhIqU0HfrZXJAIChUCq03rDbKYkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/index.vue")
  },
  {
    name: "offline",
    path: "/offline",
    component: () => import("/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/offline.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(indexXFLmaM8Fg6kkaSQzlmotpFCM0cidHJBCi0vZ4rkpn8EMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/login/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/logout/index.vue")
  },
  {
    name: "redirect-token",
    path: "/redirect/token",
    meta: token1A1cl6_45jFxr_prfaNpqaG21UDxhgvkEG12Gvc7L8geoMeta || {},
    component: () => import("/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/redirect/token.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    meta: { ...(indexS7vzSQCNplOFg9k3Es30P9a0C43vZ3bEtevuzKHlP0UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/schedule/index.vue")
  },
  {
    name: "students",
    path: "/students",
    meta: { ...(indexuJ4ocsEYmNNHQvvDFJ_45gjC0sZPOqY3oP5cW_IIQ4nOQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/pages/students/index.vue")
  }
]